import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import userService from "@/services/modules/userService";
const attachment = () =>
  import(
    /* webpackChunkName: "attachment" */ "@/components/AccountPage/Kyc/AutoKyc/InternationalCard/Attachment/index"
  );
const Cropper = () =>
  import(/* webpackChunkName: "cropper" */ "@/components/Shared/Cropper");
const TakePhoto = () =>
  import(
    /* webpackChunkName: "cropper" */ "@/components/AccountPage/Kyc/ManualKyc/takePhoto/index"
  );
export default {
  name: "manual-kyc",
  data() {
    return {
      isModalOpen: false,
      isRequesting: false,
      imageViewerModal: false,
      loadImage: false,
      file: null,
      fileRules: "",
      personalImage: require("@/assets/image/okend.jpg"),
      url: null,
      urls: {},
      editedImage: null,
      attachments: [],
      model: {}
    };
  },
  components: {
    attachment,
    Cropper,
    TakePhoto
  },
  computed: {
    ...mapGetters({
      initData: types.init.getters.GET_INIT_DATA
    })
  },
  mounted() {
    this.getAllAttachments();
  },
  methods: {
    ...mapActions({
      setImage: types.userVerifyInfo.actions.SET_IMAGE_STATUS
    }),
    getAllAttachments() {
      userService.getAttachments().then(response => {
        this.attachments = response.data.data;
      });
    },
    openKYCNormalModal() {
      this.isModalOpen = true;
    },
    closePictureModal() {
      this.resetPhoto();
      this.isModalOpen = false;
    },
    resetPhoto(name) {
      this.model[name] = null;
      this.editedImage = null;
    },
    uploadImage() {
      userService
        .uploadFile(this.model)
        .then(res => {
          this.closePictureModal();
          this.setImage("PROCESSING");
          this.$toast.success(res.data.message);
          this.$router.push({ name: "kycResult" });
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    },
    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },
    editImage(name) {
      this.$refs[name][0].openEditModal();
    },
    onGetImage(data, name) {
      this.$set(this.urls, name, URL.createObjectURL(data));
      // this.url = URL.createObjectURL(data);
      this.editedImage = data;
    },
    deleteImage(name) {
      this.urls[name] = null;
      this.model[name] = null;
      this.fileRules = "";
      // this.loadImage = false
    },
    setFile(file, name) {
      // this.url = URL.createObjectURL(file);
      // this.model[name] = file;
      // console.log(this.model)

      this.$set(this.model, name, file);
      this.$set(this.urls, name, URL.createObjectURL(file));
      console.log(this.urls);
      this.onGetImage(file);
      this.loadImage = true;
      if (file) {
        const maxSize = this.initData.kyc.image.maximum_file_size;
        const minSize = this.initData.kyc.image.minimum_file_size;
        const fileSize = file.size / 1000;
        const isJpeg = file.type === "image/jpeg";
        const isPng = file.type === "image/png";
        if (!isPng && !isJpeg) {
          this.urls[name] = undefined;
          this.fileRules = this.$t(
            "ticketsPage.createTicket.attachment.fileFormatIsNotCorrect"
          );
        } else if (fileSize > maxSize) {
          this.fileRules = this.$t(
            "ticketsPage.createTicket.attachment.moreThanMaxSize",
            { count: this.initData.kyc.image.maximum_file_size / 1000 }
          );
          this.urls[name] = undefined;
        } else if (fileSize < minSize) {
          this.fileRules = this.$t(
            "ticketsPage.createTicket.attachment.lessThanMinSize",
            { count: this.initData.kyc.image.minimum_file_size / 1000 }
          );
          this.urls[name] = undefined;
        } else {
          this.fileRules = "";
        }
      }
    }
  }
};
